class MarqueeText extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-marquee-track]');
    this.group = this.querySelector('[data-marquee-group]');

    if (!this.track || !this.group) return;

    // Jeu d'items d'origine, conservé pour pouvoir recalculer proprement.
    this.items = Array.from(this.group.children).map((item) => item.cloneNode(true));

    this.render = this.render.bind(this);
    this.render();

    // Un ResizeObserver sur le bloc bouclerait : render() modifie sa largeur.
    this.onResize = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.render, 150);
    };

    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    clearTimeout(this.resizeTimer);
  }

  render() {
    // Largeur utile du document : exclut la barre de défilement, contrairement
    // à 100vw qui provoquerait un débordement horizontal de la page.
    this.style.setProperty('--marquee-vw', `${document.documentElement.clientWidth}px`);

    const gap = Number.parseFloat(getComputedStyle(this.group).gap) || 0;

    // On repart d'un seul groupe contenant le jeu d'items d'origine.
    this.track.replaceChildren(this.group);
    this.group.replaceChildren(...this.items.map((item) => item.cloneNode(true)));

    if (this.items.length === 0) return;

    // Le groupe doit couvrir toute la largeur visible, sinon un blanc apparaît
    // entre les deux copies pendant le défilement.
    const target = this.clientWidth;
    let guard = 0;

    while (this.group.scrollWidth < target && guard < 50) {
      this.group.append(...this.items.map((item) => item.cloneNode(true)));
      guard += 1;
    }

    const distance = this.group.scrollWidth + gap;
    const speed = Number.parseFloat(this.dataset.speed) || 100;
    this.style.setProperty('--marquee-duration', `${distance / speed}s`);

    // Seconde copie : c'est elle qui prend la place de la première en fin de
    // boucle et rend le défilement continu.
    const clone = this.group.cloneNode(true);
    delete clone.dataset.marqueeGroup;
    this.track.append(clone);
  }
}

if (!customElements.get('marquee-text')) {
  customElements.define('marquee-text', MarqueeText);
}
